import { Flex, Skeleton, Space } from "antd";

const SapDocumentsSkeleton = () => {
  return (
    <Flex gap={8}>
      <Space>
        <Skeleton.Button
          active={true}
          shape={"square"}
          style={{ width: "60px", height: "70px" }}
        />
        <Skeleton.Button
          active={true}
          shape={"square"}
          style={{ width: "60px", height: "70px" }}
        />
        <Skeleton.Button
          active={true}
          shape={"square"}
          style={{ width: "60px", height: "70px" }}
        />
        <Skeleton.Button
          active={true}
          shape={"square"}
          style={{ width: "60px", height: "70px" }}
        />
      </Space>
    </Flex>
  );
};

export default SapDocumentsSkeleton;
